import "./services-why-us.css";
import { FaCheckCircle, FaUsers, FaRocket, FaShieldAlt } from "react-icons/fa";

const whyUsData = [
  {
    id: 1,
    icon: <FaRocket />,
    title: "Scalable & Future-Ready Solutions",
    description:
      "We design systems that grow with your business, ensuring long-term performance and adaptability.",
  },
  {
    id: 2,
    icon: <FaUsers />,
    title: "Expert Team & Proven Experience",
    description:
      "Our engineers, designers, and strategists bring deep industry expertise across multiple domains.",
  },
  {
    id: 3,
    icon: <FaShieldAlt />,
    title: "Security & Quality First",
    description:
      "We follow best practices in security, testing, and compliance to deliver reliable products.",
  },
  {
    id: 4,
    icon: <FaCheckCircle />,
    title: "Transparent Process & Support",
    description:
      "Clear communication, predictable timelines, and continuous support at every stage.",
  },
];

const ServicesWhyUs = () => {
  return (
    <section className="services-why-us">
      <div className="services-why-us__container">
        {/* HEADER */}
        <div className="services-why-us__header section-header">
          <span className="services-why-us__badge">Why Oglitz</span>

          <h2 className="services-why-us__title">
            Why Businesses Choose <span>Oglitz</span>
          </h2>

          <p className="services-why-us__subtitle">
            We combine technology, strategy, and design to build digital
            products that deliver real business impact.
          </p>
        </div>

        {/* GRID */}
        <div className="services-why-us__grid">
          {whyUsData.map((item) => (
            <div className="services-why-us__card" key={item.id}>
              <div className="services-why-us__icon">{item.icon}</div>

              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesWhyUs;
